import React, { useRef, useEffect } from "react";
import { amountToWords } from "../../../amountToWords";
import { useReactToPrint } from "react-to-print";

// npm install react-to-print

const Print_Voucher = ({ schoolDetails, headerData, detailRows, onAfterPrint }) => {

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    //content: () => printRef.current,
    contentRef: printRef,

    pageStyle: `
    @page {
      size: A4;
      margin: 12mm;
    }

    @media print {
      html,
      body {
        margin: 0;
        padding: 0;
      }

      #voucher-print-area {
        box-sizing: border-box;
        width: 100%;
      }
    }
  `,

    onAfterPrint: () => {
      onAfterPrint?.();
    },
  });


  useEffect(() => {
    if (showPrintReady()) {
      const timer = setTimeout(() => {
        handlePrint();
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [schoolDetails, detailRows]);

  const showPrintReady = () => {
    return (
      schoolDetails?.schoolName &&
      detailRows &&
      detailRows.length > 0
    );
  };


  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const voucher = {

    company: schoolDetails.schoolName,
    //address: schoolDetails.schoolAddr1 || ' ' || schoolDetails.schoolAddr2,
    address: schoolDetails.schoolAddr1.trim(),
    sectionName: schoolDetails.sectionName,
    phone: schoolDetails.schoolPhone1,
    logo_path: schoolDetails.logoPath,
    logo_name: 'school_logo.png',
    preparedBy: schoolDetails.preparedBy,
    voucherNo: headerData.vchr_no,
    date: formatDate(headerData.vchr_date),
    payee: headerData.payer_payee_name,
    detail: headerData.hdr_narration,
    amount: headerData.hdr_amt,
    narration: headerData.hdr_narration,
  };


  const parseAmount = v => Number(String(v).replace(/,/g, "") || 0);

  const totalAmount = detailRows.reduce(
    (sum, r) => sum + parseAmount(r.amount),
    0
  );

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      {/* <div style={{ fontFamily: "courier", padding: "20px" }}> */}
      {/* 🔹 Print button (not included in print area) */}
      {/* <button
        onClick={handlePrint}
        style={{
          marginBottom: "20px",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        🖨️ Print Voucher
      </button> */}

      {/* 🔹 Voucher content to be printed */}
      {/* <div ref={printRef} id="voucher-print-area" style={{ border: "2px solid #000", padding: "10px", borderRadius: "4px" }}> */}
      <div ref={printRef} id="voucher-print-area" 
           style={{ border: "4px double #000", padding: "12px", minHeight: "125mm",      // Fill printable area
                     boxSizing: "border-box", background: "#fff", }} >

        {/* HEADER */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", paddingBottom: "5px" }} >

          {/* Logo Left */}
          {voucher.logo_path && (
            <img src={`${voucher.logo_path}${voucher.logo_name}`} alt="School Logo"
              style={{ width: "70px", height: "70px", objectFit: "contain", position: "absolute", left: 0, top: 0, }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          )}

          {/* Company Details */}
          <div style={{ textAlign: "center" }}>
            <h3 style={{ margin: 0 }}> {voucher.company} </h3>
            <p style={{ margin: "2px 0", fontSize: "17px", }}> {voucher.sectionName}</p>
            <p style={{ margin: "2px 0", fontSize: "15px", }}> {voucher.address}</p>
            {/* <p style={{ margin: "2px 0", fontSize: "15px", }}> Phone: {voucher.phone}</p> */}
          </div>

        </div>


        {/* <hr style={{ border: "2px solid #000", margin: "5px 0 10px 0" }} /> */}

        {/* to draw a line */}
        <div style={{ width: "100%", borderTop: "2px solid #000", margin: "5px 0 10px 0", boxSizing: "border-box", }} />

        <table style={{ width: "100%", marginTop: "10px", maxHeight: '35px', borderCollapse: "collapse", border: "none" }}>
          <tbody>
            <tr>
              <td style={{ border: "none", fontSize: "15px" }}><strong>Voucher No:</strong> {voucher.voucherNo}</td>
              <td style={{ textAlign: 'center', border: "none" }} > <h5> PAYMENT VOUCHER </h5> </td>
              <td style={{ textAlign: "right", border: "none", fontSize: "15px" }}> <strong>Date:</strong> {voucher.date}
              </td>
            </tr>
            <tr>
              <td style={{ border: "none", fontSize: "15px" }}><strong>Paid To:</strong> {voucher.payee}</td>
              <td style={{ border: "none", fontSize: "15px" }} colSpan="2"><strong>Narration:</strong> {voucher.narration}</td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
            maxHeight: '35px'
          }}
        >
          <thead>
            <tr>
              {/* <th style={{ width: '3%', alignItems: 'center', border: "1px solid #000", padding: "6px" }}>Sr.No</th> */}
              <th style={{
                width: "3%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'
              }}>Sr. #</th>

              <th style={{
                width: '30%', textAlign: 'left', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000"
              }}>Particulars</th>
              <th style={{
                width: '12%', textAlign: 'right', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000"
              }}>Amount (₹)</th>
            </tr>
          </thead>

          <tbody>
            {detailRows && detailRows.length > 0 ? (
              detailRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontSize: "14px" }}> {index + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px" }}>{row.acct_name}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "right", fontSize: "14px" }}> {row.amount}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="3"
                  style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}
                >
                  No Data Available
                </td>
              </tr>
            )}

            {/* 🔹 TOTAL ROW */}
            <tr>
              <td
                colSpan="2"
                style={{ border: "1px solid #000", padding: "4px", textAlign: "left", fontSize: "15px" }}
              >
                <strong>Total</strong>
              </td>

              <td style={{ border: "1px solid #000", padding: "4px", textAlign: "right", fontSize: "15px" }}
              >
                <strong>
                  {totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: "10px", fontSize: "17px" }}>
          <strong>Amount in Words: </strong>
          <span>{amountToWords(totalAmount)}</span>
        </p>

        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ fontSize: "15px" }}><u>&nbsp;{voucher.preparedBy}&nbsp;</u><br />Prepared By</div>
          <div style={{ fontSize: "15px" }}>_________________<br />Authorized By</div>
          <div style={{ fontSize: "15px" }}>_________________<br />Receiver’s Signature</div>
        </div>
      </div>
    </div>
  );
};

export default Print_Voucher;
